// extracted by mini-css-extract-plugin
module.exports = {"margin":"style__margin__tLv+c","filterBlock":"style__filterBlock__25V9n","isFilter":"style__isFilter__CEVo7"};